module.exports = __webpack_public_path__ + "static/media/kubernetes.2f68e674.png";